import { createFileRoute } from "@tanstack/react-router";
import PoliciesAccessMap from "../pages/PoliciesAccessMap";

type AccessMapSearch = {
  name?: string;
  connectionName?: string;
  source?: string;
  variant?: string;
};

export const Route = createFileRoute("/_policies/access-map/$assetId")({
  component: AccessMapPage,
  validateSearch: (search: Record<string, unknown>): AccessMapSearch => ({
    name: (search.name as string) || undefined,
    connectionName: (search.connectionName as string) || undefined,
    source: (search.source as string) || undefined,
    variant: (search.variant as string) || undefined,
  }),
});

function AccessMapPage() {
  const { assetId } = Route.useParams();

  return <PoliciesAccessMap assetId={assetId} />;
}
